import { DateTimeFormat, formatDateTime } from '@occc-app/lib/date';
import { separateEveryThousandByComma } from '@occc-app/lib/numbers';
import { formatMoneyAmount } from '@occc-app/lib/currency';
import { StatusIndicatorColors } from '@occc/ui-design-system';

import { ScanDataSubmissionStatus } from './tobacco-submissions.types';

export const formatSubmittedAt = (date: string | Date) =>
  formatDateTime(new Date(date), DateTimeFormat.DateSlashed);

export const formatInt = (n: number) => separateEveryThousandByComma(n);

export const formatUsdCents = (cents: number) => formatMoneyAmount(cents, { fromCents: true });

export const getScanDataSubmissionStatusParams = (
  status: ScanDataSubmissionStatus,
): { label: string; color: StatusIndicatorColors } => {
  if (status === 'SUBMITTED') {
    return { label: 'Submitted', color: 'green' };
  }
  if (status === 'NOT_SUBMITTED') {
    return { label: 'Not Submitted', color: 'red' };
  }
  return { label: 'Partially Submitted', color: 'yellow' };
};

export const toOCDate = (date: Date) => date.toISOString().slice(0, 10);
